module.exports = __webpack_public_path__ + "static/WEDDING E&M-116-f01718ba8ed4323e6fa1b751a592dbf9.jpg";